module.exports = __webpack_public_path__ + "media/images/ic_bronze_medal-39f7f06c89c86de6101d526f2ca7cd8a.png";